

import { useContext, useState, useEffect } from "react";
import { GlobalStateContext, GlobalStateProvider } from "../../utils/GlobalStateContext";

const UserDetails = () => {

const curState = useContext(GlobalStateContext);
const BASE_URL = process.env.REACT_APP_API_URL;

const[ staff_name, set_staff_name] = useState(0)
const[ patient_name, set_patient_name] = useState("No patient selected")
const[ patientMrn, setPatientMrn] = useState(null);

// The staff is stored as a clidnician.id
// This will find the clinician name
  useEffect(() => {
    // Checking to see if we have these actaully stored in global vars
    const currentUser = curState?.currentUser;
    const currentPatient = curState?.currentPatient;

    //If we have a current patient, we will set their name here, otherwise it will display "No patient selected"
    if (currentPatient != undefined && currentPatient?.first_name && currentPatient?.last_name) {
        // Set the patient name by combining first and last names
      set_patient_name(currentPatient.first_name + ' ' + currentPatient.last_name)
    }

    if (currentUser)  {
        set_staff_name(currentUser.first_name + ' ' + currentUser.last_name)
    }

    });

  useEffect(() => {
    const risId = curState?.currentPatient?.ris_patients_id;
    if (!risId) { setPatientMrn(null); return; }
    fetch(`${BASE_URL}/patientIdentity/status?ris_patient_id=${risId}`)
      .then(r => r.json())
      .then(d => setPatientMrn(d.mrn ?? null))
      .catch(() => setPatientMrn(null));
  }, [curState?.currentPatient?.ris_patients_id]);
    

 
  return (
    <div>
        <h2>User Information</h2>
        <p>Patient: {patient_name}</p>
        {curState?.currentPatient?.ris_patients_id && (
            <p>ID: {curState.currentPatient.ris_patients_id}</p>
        )}
        {patientMrn && (
            <p>MRN: {patientMrn}</p>
        )}
        <p>Staff: {staff_name}</p>
    </div>

  );
};

export default UserDetails;